import React, { useState, useCallback } from "react";
import {
  Card,
  Avatar,
  Typography,
  Box,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AndroidIcon from "@mui/icons-material/Android";
import AppleIcon from "@mui/icons-material/Apple";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { useMap } from "@vis.gl/react-google-maps";
import { useSelector } from "react-redux";

const DriverList = ({
  allDrivers = [],
  availabledrivers = [],
  setSelectedDriver,
  setMapCenter,
  userType,
  subcmpnyName,
  selectedstatus = "",
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(true);
  const map = useMap();
  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );
  // Decide source
  const driverSource =
  availabledrivers && availabledrivers.length > 0
  ? availabledrivers
  : allDrivers;
  
  const isNoDriversFound =
  driverSource.length === 1 && driverSource[0]?.no_drivers;
  console.log(selectedstatus)
  // Filter drivers
  const filteredDrivers = !isNoDriversFound
    ? driverSource.filter((driver) => {
        // Exclude deactivated accounts
        if (driver?.driver_ride_details?.driverAccountStatus === "DE_ACTIVE") {
          return false;
        }

        // Filter by rideStatus when a specific status is selected (ACTIVE, OFFLINE, RIDING)
        if (selectedstatus && selectedstatus !== "ALL") {
          if (
            driver?.driver_ride_details?.rideStatus &&
            driver?.driver_ride_details?.rideStatus !== selectedstatus
          ) {
            return false;
          }
        }

        if (userType === "SUB COMPANY" && subcmpnyName) {
          if (
            driver?.driver_ride_details?.sub_companyName !== subcmpnyName
          ) {
            return false;
          }
        }
        
        if (
          demoaccount_id &&
          driver?.demoaccount_id &&
          driver.demoaccount_id !== demoaccount_id
        ) {
          return false;
        }

        const firstName = driver?.firstName?.toLowerCase() || "";
        const lastName = driver?.lastName?.toLowerCase() || "";
        const fullName = `${firstName} ${lastName}`.trim();
        const driverId = String(driver?.driverId || "").toLowerCase();
        const serviceName = String(
          driver?.driver_ride_details?.service_details?.serviceName || ""
        ).toLowerCase();
        const search = searchTerm.toLowerCase().trim();

        if (!search) return true;

        return (
          firstName.includes(search) ||
          lastName.includes(search) ||
          fullName.includes(search) ||
          driverId.includes(search) ||
          serviceName.includes(search)
        );
      })
    : [];
      console.log(filteredDrivers);

  // Select driver and move map
  const handleSelectdriver = useCallback(
    (row) => {
      setSelectedDriver(row);

      const newLatLng = {
        lat: Number(row?.driver_ride_details?.latitude),
        lng: Number(row?.driver_ride_details?.longitude),
      };

      setMapCenter((prevCenter) =>
        prevCenter?.lat !== newLatLng.lat ||
        prevCenter?.lng !== newLatLng.lng
          ? newLatLng
          : prevCenter
      );

      if (map) {
        map.panTo(newLatLng);
        // Zoom in to show exact street (zoom level 15 = street view)
        map.setZoom(15);
      }
    },
    [map, setSelectedDriver, setMapCenter]
  );

  return (
    <Box>
      {/* Slide Button */}
      <IconButton
        onClick={() => setIsOpen(!isOpen)}
        sx={{
          position: "absolute",
          top: 100,
          left: isOpen ? 380 : 10,
          zIndex: 10,
          background: "#fff",
          boxShadow: 3,
          "&:hover": { background: "#fff" },
        }}
      >
        {isOpen ? <ChevronLeft /> : <ChevronRight />}
      </IconButton>

      {/* Main Card */}
      <Card
        sx={{
          position: "absolute",
          top: 80,
          left: isOpen ? 20 : "-420px",
          width: 370,
          height: "80vh",
          overflowY: "auto",
          borderRadius: "20px",
          p: 2,
          transition: "all 0.3s ease",
        }}
      >
        {/* Search */}
        <TextField
          fullWidth
          placeholder="Search for drivers"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{
            mb: 2,
            "& .MuiOutlinedInput-root": {
              borderRadius: "30px",
              background: "#f5f6f8",
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />

        {/* Driver Cards */}
        {isNoDriversFound ? (
          <Typography align="center">
            {driverSource[0]?.no_drivers}
          </Typography>
        ) : filteredDrivers.length > 0 ? (
          filteredDrivers.map((driver, index) => {
            const rideStatus =
              driver?.driver_ride_details?.rideStatus;

            const statusColor =
              rideStatus === "ACTIVE"
                ? "green"
                : rideStatus === "RIDING"
                ? "blue"
                : "red";

            const statusText =
              rideStatus === "ACTIVE"
                ? "Online"
                : rideStatus === "RIDING"
                ? "Riding"
                : "Offline";

            return (
              <Card
                key={index}
                onClick={() => handleSelectdriver(driver)}
                sx={{
                  mb: 2,
                  p: 1,
                  borderRadius: "16px",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                  "&:hover": {
                    boxShadow: "0 6px 18px rgba(0,0,0,0.1)",
                  },
                }}
              >
                <Box display="flex" justifyContent="space-between">
                  {/* Left Section */}
                  <Box >
                    <Box display="flex" justifyContent="space-between">

                    <Avatar
                      src={driver.image ? driver.image : "/assets/images/driverdefaultimg.png"}
                      imgProps={{
    onError: (e) => {
      e.target.src = "/assets/images/driverdefaultimg.png";
    },}}
                      sx={{ width: 50, height: 50, mr: 2 }}
                      />

                  <Box>

               

                      <Typography fontWeight={500}>
                        {driver?.firstName} -{" "}
                        {
                          driver?.driver_ride_details
                          ?.service_details?.serviceName
                        }
                      </Typography>
                      <Typography fontWeight={600}>
                        {driver?.driverId || "ID"}
                      </Typography>
                      
                         </Box>
                        </Box>

{/* Rating + Trips */}
                      <Box display="flex" gap={1} mt={1}>
                        <Box
                          sx={{
                            background: "#f3f4f6",
                            px: 0.5,
                            py: 0.5,
                            borderRadius: "20px",
                            fontSize: 12,
                          }}
                        >
                          ⭐ {driver?.driver_ride_details?.rating || driver?.rating || "4.8"} Rating
                        </Box>

                        <Box
                          sx={{
                            background: "#f3f4f6",
                            px: 0.5,
                            py: 0.5,
                            borderRadius: "20px",
                            fontSize: 12,
                          }}
                        >
                          🚗 {driver?.driver_ride_details?.total_requests?.length || driver?.totalTrips || "0"} trips
                        </Box>
                      </Box>

<Box display="flex" gap={1} mt={1}>


                      {/* Device */}
                      <Typography mt={1} fontSize={13}>
                        Devices:{" "}
                        {driver?.device_type === "android" ? (
                          <AndroidIcon
                            fontSize="small"
                            sx={{ color: "green" }}
                          />
                        ) : (
                          <AppleIcon fontSize="small" />
                        )}
                      </Typography>

                      {/* Status */}
                      <Typography
                        fontSize={13}
                        mt={1}
                        fontWeight={500}
                        sx={{ color: statusColor }}
                      >
                        Status: {statusText}
                      </Typography>
                      </Box>
                    
                  </Box>

                  {/* Vehicle Image */}
                  {driver?.driver_ride_details?.service_details
                    ?.serviceImage && (
                      <Box sx={{display:"flex",flexDirection:"column"}}>
                      <img
            src={ rideStatus === "ACTIVE"
                ? "/assets/images/DispatcherIcons/dispatcheractive.png"
                : rideStatus === "RIDING"
                ? "/assets/images/DispatcherIcons/dispatcherride.png"
                : "/assets/images/DispatcherIcons/dispatcheroffline.png"}
            alt="email"
            width="20"
            style={{ pointerEvents: "none",marginLeft:"70%" }}
          />
                    <Box
                      component="img"
                      src={
                        driver.driver_ride_details.service_details
                          .serviceImage
                      }
                      alt="Vehicle"
                      sx={{
                        width: 110,
                        height: 60,
                        objectFit: "contain",
                        marginTop:"10%",
                      }}
                    />
                  </Box>
                  )}
                </Box>
              </Card>
            );
          })
        ) : (
          <Typography align="center">
            No drivers found
          </Typography>
        )}
      </Card>
    </Box>
  );
};

export default DriverList;